__webpack_require__.p = "https://payment-processing-pmnts-staging.getsquire.com/";